import React, { useState, useEffect, useCallback } from "react";
import { useNavigate } from "react-router-dom";
import SelectionCard from "./components/selectionCard";
import api from "./utils/api";

function Home() {
  const navigate = useNavigate();

  const [activeGames, setActiveGames] = useState([]);
  const [isLoading, setIsLoading] = useState(false); // Add this line

  useEffect(() => {
    // Fetch the static game configuration

    // Fetch active games from the API
    api
      .get("/api/game/index.php?active=1")
      .then((response) => {
        console.log("Active games from API:", response.data);
        setActiveGames(response.data);
      })
      .catch((error) => {
        console.error("Error fetching active games:", error);
      });
  }, []);

  const shuffleArray = (array) => {
    return array.sort(() => Math.random() - 0.5);
  };

  // Function to randomly shuffle and select 10 records from the filtered list
  const selectRandomKurals = useCallback((kuralArray, numRecords) => {
    const shuffled = shuffleArray([...kuralArray]);
    return shuffled.slice(0, numRecords);
  }, []);

  const handleStartGame = async (
    no,
    athikaram,
    time,
    titile,
    level,
    datafile,
    gameid
  ) => {
    try {
      setIsLoading(true); // Set loading to true when starting
      // First, make the API call and wait for it to complete
      const apiResponse = await api.get(
        "/api/kural/index.php?athikarams=" + athikaram
      );

      // Map the API response data to the requested format, including kural_line1 and kural_line2
      const mappedKurals = apiResponse.data.map((item) => ({
        chapter: item.athikaram,
        kural: [
          item.kural_line1.replace(/\./g, ""),
          item.kural_line2.replace(/\./g, ""),
        ],
        kural_line1: item.kural_line1.replace(/\./g, ""),
        kural_line2: item.kural_line2.replace(/\./g, ""),
        kuralText: item.kural,
      }));

      const selectedKuralSet = selectRandomKurals(mappedKurals, no);
      console.log("selectedKuralSet:", mappedKurals);

      if (level === 1) {
        navigate("/aattam/1", {
          state: {
            data: selectedKuralSet,
            message: athikaram,
            number: no,
            time: time,
            titile: titile,
            gameid: gameid,
          },
        });
      } else if (level === 2) {
        navigate("/aattam/2", {
          state: {
            data: selectedKuralSet,
            message: athikaram,
            number: no,
            time: time,
            titile: titile,
            gameid: gameid,
          },
        });
      }
    } catch (error) {
      console.error("Error in game start process:", error);
      // You could add error handling UI here
      alert("Error starting game. Please try again.");
    } finally {
      setIsLoading(false); // Always set loading to false when done
    }
  };

  // Add this before the return statement
  const LoadingOverlay = () => {
    if (!isLoading) return null;

    return (
      <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
        <div className="bg-white p-5 rounded-lg flex flex-col items-center">
          <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-blue-500 mb-3"></div>
          <p className="text-gray-700">Loading game data...</p>
        </div>
      </div>
    );
  };

  return (
    <>
      <LoadingOverlay /> {/* Add this line */}
      <div className="p-2 max-w-full mx-auto">
        <div className="grid grid-cols-1 gap-3">
          {/* Display games from static config */}

          {/* Display games from API */}
          {activeGames.length > 0 && (
            <div className="mt-4">
              <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4 mb-6 p-4">
                {activeGames.map((game, index) => (
                  <div key={`api-game-${index}`}>
                    <SelectionCard
                      key={`api-game-${index}`}
                      handleClick={handleStartGame}
                      no={game.noOfKurals || 10}
                      x
                      time={game.duration || 60}
                      titile={game.gameName}
                      athikaram={game.athikaram || "[]"}
                      gradient={"bg-gradient-to-r from-blue-500 to-purple-500"} // Default gradient // Use random gradient for each card
                      isGameDisabled={game.isDisabled === 1}
                      level={game.gameLevel || 1} // Default level
                      datafile={""} // No datafile for API games
                      gameid={game.id}
                    />
                  </div>
                ))}
              </div>
            </div>
          )}
        </div>
      </div>
    </>
  );
}

export default Home;
